export const GROUP_PRIVATE = 'private';
export const GROUP_PUBLIC = 'public';
export const GROUP_HIDDEN = 'hidden';
export const MAX_CATEGORIES_NB = 3;
export const ACCEPT_USERS = 'acceptUsers';
export const INVITE_USERS = 'inviteUsers';
export const MANAGE_ROLES = 'manageRoles';
export const PUBLISH_FILES = 'publishFiles';
export const MODIFY_INFO = 'modifyInfo';
export const KICK_USERS = 'kickUsers';
export const MANAGE_TAGS = 'manageTags';
export const ADMINISTRATOR = 'administrator';
export const TAG_OWN_FILES = 'tagOwnFiles';
export const DELETE_POSTS = 'deletePosts';

const useLocalhost = false;
//export const TORRESOWO_URL = (window.location.hostname === "localhost" && useLocalhost) ? 'http://192.168.1.66:8085' : 'https://torresowo.myftp.org:8082';
export const TORRESOWO_URL = 'https://torresowo.myftp.org:8082';

export const TORRESOWO_FILE_URL = 'https://torresowo.myftp.org/cap17drive/v2/';

export const getFileUrl = (file) => {

    if (!file?.storeUrl) {
        return null;
    }

    if (file.storeUrl.startsWith('http')) {
        return file.storeUrl;
    }

    return TORRESOWO_FILE_URL + file.storeUrl + '?withName=' + file.fileName;
}

export const BASE_IMAGE_TMDB = TORRESOWO_URL + '/tmdb/image/';

export const getTmdbImage = (path, size = 'original') => {
    return BASE_IMAGE_TMDB + size + (path ?? "/undefined");
}


